'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconAliases = require('icons/iconAliases');

var _iconAliases2 = _interopRequireDefault(_iconAliases);

var _reactUtils = require('react-utils');

var _Style = require('../core/Style');

var _IconConstants = require('./IconConstants');

var _iconName = require('../utils/propTypes/iconName');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var minSize = 9; // See HubSpot/UIComponents#4436

var getIconClassName = function getIconClassName(size, measuredSize) {
  size = size || measuredSize;
  if (size === null) {
    size = 'high';
  } else if (_IconConstants.ICON_SIZES[size]) {
    size = _IconConstants.ICON_SIZES[size] <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
  } else if (typeof size === 'number') {
    size = size <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
  }
  return 'private-icon__' + size;
};

var getClassName = function getClassName(className, size, measuredSize) {
  return (0, _reactUtils.classNames)('private-icon', getIconClassName(size, measuredSize), className);
};

var getComputedFontSize = function getComputedFontSize(size) {
  if (!size) return null;

  if (_IconConstants.ICON_SIZES.hasOwnProperty(size)) {
    return (0, _Style.remCalc)(_IconConstants.ICON_SIZES[size]);
  }

  if (size < minSize) {
    _devLogger2.default.warn({
      message: 'UIIcon: size={' + size + '} is too small. The minimum is size={' + minSize + '}.',
      key: 'UIIcon too small'
    });
    return (0, _Style.remCalc)(minSize);
  }

  return (0, _Style.remCalc)(size);
};

var UIIcon = _react2.default.createClass({
  displayName: 'UIIcon',

  mixins: [_reactAddonsPureRenderMixin2.default],
  propTypes: {
    color: _react.PropTypes.string,
    className: _react.PropTypes.string,
    name: (0, _iconName.getIconNamePropType)().isRequired,
    size: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(Object.keys(_IconConstants.ICON_SIZES)), _react.PropTypes.number]),
    style: _react.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      measuredSize: null
    };
  },
  componentDidMount: function componentDidMount() {
    setTimeout(this.measureSize, 0);
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.measuredSize === this.state.measuredSize) {
      this.measureSize();
    }
  },
  measureSize: function measureSize() {
    if (!this._span) {
      return;
    }
    if (this.props.size) {
      return;
    }
    var styles = window.getComputedStyle(this._span, null);
    if (styles == null) {
      // See #4208
      return;
    }
    var measuredSize = parseInt(styles.fontSize, 10);
    if (measuredSize !== this.state.measuredSize) {
      this.setState({
        measuredSize: measuredSize
      });
      if (measuredSize > 64 || this._span.offsetHeight > 64) {
        _devLogger2.default.warn({
          message: 'Icon "' + this.props.name + '" is too large, consider using an illustration instead.',
          key: 'UIIcon too large'
        });
      }
    }
  },
  spanRefCallback: function spanRefCallback(ref) {
    this._span = ref;
  },
  render: function render() {
    var _props = this.props,
        color = _props.color,
        className = _props.className,
        name = _props.name,
        style = _props.style,
        size = _props.size,
        rest = _objectWithoutProperties(_props, ['color', 'className', 'name', 'style', 'size']);

    var measuredSize = this.state.measuredSize;

    var computedName = _iconAliases2.default[name] || name;

    return _react2.default.createElement(
      'span',
      _extends({}, rest, {
        'aria-hidden': true,
        className: getClassName(className, size, measuredSize),
        ref: this.spanRefCallback,
        style: _extends({
          color: color
        }, style, {
          fontSize: getComputedFontSize(size)
        })
      }),
      computedName
    );
  }
});

exports.default = UIIcon;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/icon/UIIcon.js
// module id = 9
// module chunks = 0